<div (click)="openDetail(cargo)">
  {{cargo.consecutive}} - {{cargo.dateLoad | date}}
</div>